import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Flag } from "@phosphor-icons/react";
import { renderToString } from "react-dom/server";

interface PhosphorClockInMarkerProps {
  position: [number, number];
  popupContent?: React.ReactNode;
}

export const ClockInMarker: React.FC<PhosphorClockInMarkerProps> = ({
  position,
  popupContent,
}) => {
  const iconHtml = renderToString(<Flag size={28} weight="fill" color="#0f7e00" />);

  const customIcon = L.divIcon({
    html: iconHtml,
    className: "custom-phosphor-icon",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  return (
    <Marker position={position} icon={customIcon}>
      {popupContent && <Popup>{popupContent}</Popup>}
    </Marker>
  );
};
